"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5275],{

/***/ 65447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ Select; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Badges_OptionalBadge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87881);
/* harmony import */ var _components_Badges_RequiredBadge__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32736);
/* harmony import */ var _hookform_error_message__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(32866);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43153);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Styles__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60487);







const Select = (param)=>{
    let { label , hasOptionalBadge , hasRequiredBadge , path , disabled =false , register , registerOptions ={} , options , errors ={} , labelCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultLabelCN */ .oi , selectCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultSelectCN */ .k3 , selectErrorStateCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultSelectErrorStateCN */ .B1 , errorMessageCN =_Styles__WEBPACK_IMPORTED_MODULE_4__/* .defaultErrorMessageCN */ .yr  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                htmlFor: path,
                className: labelCN,
                children: [
                    label,
                    " ",
                    hasOptionalBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Badges_OptionalBadge__WEBPACK_IMPORTED_MODULE_1__/* .OptionalBadge */ .E, {}),
                    " ",
                    hasRequiredBadge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Badges_RequiredBadge__WEBPACK_IMPORTED_MODULE_2__/* .RequiredBadge */ .B, {})
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("select", {
                id: path,
                disabled: disabled,
                ...register(path, registerOptions),
                className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_5__/* .classNames */ .A)(lodash_get__WEBPACK_IMPORTED_MODULE_3___default()(errors, path) ? selectErrorStateCN : "", selectCN),
                children: options
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_hookform_error_message__WEBPACK_IMPORTED_MODULE_6__/* .ErrorMessage */ .B, {
                errors: errors,
                name: path,
                render: (param)=>/*#__PURE__*/ {
                    let { message  } = param;
                    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: errorMessageCN,
                        children: message
                    });
                }
            })
        ]
    });
};


/***/ }),

/***/ 35275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "g": function() { return /* binding */ JobPostEditor; },
  "t": function() { return /* binding */ JobPostEditorPhase; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-spinners/index.js
var react_spinners = __webpack_require__(74040);
// EXTERNAL MODULE: ./utils/classNames.ts
var classNames = __webpack_require__(43153);
// EXTERNAL MODULE: ./node_modules/.prisma/client/index-browser.js
var index_browser = __webpack_require__(22804);
// EXTERNAL MODULE: ./utils/formatters/moneyFormatter.ts
var moneyFormatter = __webpack_require__(59614);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/switch/switch.js + 4 modules
var switch_switch = __webpack_require__(21551);
;// CONCATENATED MODULE: ./components/Content/SkuDescriptions.tsx

const JobPostPublishSkuDescription = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
        className: "space-y-2",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: "Published forever, or until you stop it."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: "Edit, stop or resume the post at anytime."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                children: "See how many people interacted with your post."
            })
        ]
    });
const JobPostStickySkuDescription = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "space-y-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
            children: "Your job will stay at the top of the homepage for 1 month, catching every visitor's eye."
        })
    });
const JobPostThreeTweetsSkuDescription = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: "space-y-2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
            children: [
                "We'll tweet your job to our",
                " ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "https://twitter.com/@jobsinjs",
                    target: "_blank",
                    className: "underline",
                    children: "18k followers"
                }),
                ", reaching even more potential applicants."
            ]
        })
    });

;// CONCATENATED MODULE: ./components/JobPost/editor/components/JobPostPublish.tsx







const JOB_POST_PUBLISH_SKU_ID = "106c4537-02d2-4e63-8a77-c27aa166e2a9";
const JobPostPublish = (param)=>{
    let { availableSkus , selectedSkuIds , setSelectedSkuIds , onSubmit  } = param;
    const sortedAvailableSkus = availableSkus.sort((a, b)=>a.sortOrder - b.sortOrder);
    const onToggleSkuId = (skuId)=>{
        const ids = selectedSkuIds.includes(skuId) ? selectedSkuIds.filter((i)=>i !== skuId) : [
            ...selectedSkuIds,
            skuId
        ];
        setSelectedSkuIds(ids);
    };
    // basket price
    const getBasketPriceAmount = (selectedSkuIds)=>{
        const amount = selectedSkuIds// get SKUs from skuIds
        .map((id)=>availableSkus.find((sku)=>sku.id === id))// get priceAmount
        .map((sku)=>sku.priceAmount)// sum up
        .reduce((a, b)=>a + b, 0);
        return amount;
    };
    const basketPriceAmount = getBasketPriceAmount(selectedSkuIds);
    const isDisabled = !selectedSkuIds.some((id)=>id === JOB_POST_PUBLISH_SKU_ID) && basketPriceAmount === 0;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "m-0.5 py-4 mb-6 shadow rounded-md bg-green-200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "",
                children: sortedAvailableSkus.map((sku, idx)=>{
                    const isSelected = selectedSkuIds.includes(sku.id);
                    const isToggleDisabled = sku.isRequiredForJobPost;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            sku.id === JOB_POST_PUBLISH_SKU_ID && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-2 px-4 text-xs font-bold uppercase text-green-900/60",
                                children: "Publish"
                            }),
                            availableSkus.some((param)=>{
                                let { id  } = param;
                                return id === JOB_POST_PUBLISH_SKU_ID;
                            }) ? idx === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-6 mb-2 px-4 text-xs font-bold uppercase text-green-900/60",
                                children: "Boost visibility"
                            }) : idx === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-2 px-4 text-xs font-bold uppercase text-green-900/60",
                                children: "Boost visibility"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (0,classNames/* classNames */.A)("flex justify-between px-4 pt-2 pb-8 text-xs border-t border-green-900/10", !isSelected && " bg-green-900/5"),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "w-full",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mb-2",
                                            children: !isToggleDisabled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "pt-1",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(switch_switch/* Switch */.r, {
                                                    checked: isSelected,
                                                    onChange: ()=>onToggleSkuId(sku.id),
                                                    className: (0,classNames/* classNames */.A)(isSelected ? "bg-black" : "bg-green-900/10", "relative inline-flex flex-shrink-0 h-4 w-9 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "sr-only",
                                                            children: "Use setting"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            "aria-hidden": "true",
                                                            className: (0,classNames/* classNames */.A)(isSelected ? "translate-x-5" : "translate-x-0", "pointer-events-none inline-block h-3 w-3 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200")
                                                        })
                                                    ]
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "flex flex-row justify-between w-full mb-2 text-sm font-bold",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "",
                                                            children: [
                                                                sku.name,
                                                                " ",
                                                                sku.customProperties.boost && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "relative -top-0.5 inline-block ml-1 px-2 text-xxs font-medium text-green-900/90 bg-green-900/10 rounded-xl",
                                                                    children: sku.customProperties.boost
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "",
                                                            children: sku.priceAmount > 0 ? moneyFormatter/* moneyFormatter.format */.e.format(sku.priceAmount / 100) : "Free"
                                                        })
                                                    ]
                                                }),
                                                sku.type === index_browser.SkuType.JOB_POST_PUBLISH ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostPublishSkuDescription, {}) : sku.type === index_browser.SkuType.JOB_POST_STICKY ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostStickySkuDescription, {}) : sku.type === index_browser.SkuType.JOB_POST_THREE_TWEETS ? /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostThreeTweetsSkuDescription, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: sku.description
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }, sku.id)
                        ]
                    }, sku.id);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    type: "button",
                    className: (0,classNames/* classNames */.A)(isDisabled ? "text-black border-none bg-green-900/10" : "bg-black focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-black", "inline-flex items-center mx-4 mt-4 mb-1 px-4 py-3 text-sm font-medium text-white border border-transparent shadow-sm rounded-md"),
                    onClick: onSubmit,
                    disabled: isDisabled,
                    children: basketPriceAmount ? "Checkout: ".concat(moneyFormatter/* moneyFormatter.format */.e.format(basketPriceAmount / 100)) : "Checkout: $0"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/JobPost/editor/components/JobPostSummary.tsx
var JobPostSummary = __webpack_require__(97207);
// EXTERNAL MODULE: ./node_modules/@prisma/client/index-browser.js
var client_index_browser = __webpack_require__(70385);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./components/ToggleSwitch/ToggleSwitch.tsx




const ToggleSwitch = (param)=>/*#__PURE__*/ {
    let { checked , onChange  } = param;
    return (0,jsx_runtime.jsxs)(switch_switch/* Switch */.r, {
        checked: checked,
        onChange: onChange,
        className: (0,classNames/* classNames */.A)(checked ? "bg-black" : "bg-gray-200", "relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "toggle switch"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "aria-hidden": "true",
                className: (0,classNames/* classNames */.A)(checked ? "translate-x-5" : "translate-x-0", "pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200")
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Badges/OptionalBadge.tsx
var OptionalBadge = __webpack_require__(87881);
;// CONCATENATED MODULE: ./components/Layout/JobPostEditorSectionLayout.tsx





const JobPostEditorSectionLayout = (param)=>/*#__PURE__*/ {
    let { title , description , hasToggle =false , isToggled =false , onToggle =()=>{} , children , isLast =false  } = param;
    return (0,jsx_runtime.jsxs)("div", {
        className: (0,classNames/* classNames */.A)(isLast ? "" : "border-b border-gray-200"),
        children: [
            title || hasToggle || description ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-4 pt-5 pb-6 sm:px-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: (0,classNames/* classNames */.A)(!hasToggle || isToggled ? "text-black" : "text-gray-300", "text-2xl leading-6 font-bold"),
                                children: [
                                    title,
                                    " ",
                                    hasToggle && /*#__PURE__*/ (0,jsx_runtime.jsx)(OptionalBadge/* OptionalBadge */.E, {})
                                ]
                            }),
                            hasToggle && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToggleSwitch, {
                                checked: isToggled,
                                onChange: onToggle
                            })
                        ]
                    }),
                    description && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-1 text-sm text-gray-400",
                        children: description
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-4"
            }),
            (!hasToggle || isToggled) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-4 pb-7 sm:px-6",
                children: children
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/react-script-hook/lib/index.js
var lib = __webpack_require__(73054);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./components/PlacesAutocomplete/GoogleMapsApiProvider.tsx


const GoogleMapsApiProvider = (param)=>{
    let { children  } = param;
    // load external Google API script that is required in order to make the autocomplete work
    const [loading, error] = lib_default()({
        src: "https://maps.googleapis.com/maps/api/js?key=".concat("AIzaSyC66KvqtVD4W13b3ZQ4YEAnM1rtgrBodTg", "&libraries=places")
    });
    return !loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: children
    }) : null;
};

// EXTERNAL MODULE: ./node_modules/@mui/material/TextField/TextField.js + 36 modules
var TextField = __webpack_require__(21658);
// EXTERNAL MODULE: ./node_modules/@mui/material/Autocomplete/Autocomplete.js + 20 modules
var Autocomplete = __webpack_require__(50438);
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js + 1 modules
var Paper = __webpack_require__(55113);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
;// CONCATENATED MODULE: ./components/AsyncAutocomplete/AsyncAutocompleteRemoteRegions.tsx







// Fetch jobPosts. (based on search params)
const fetchRemoteRegions = async ()=>{
    const url = "/api/job-posts/remote-regions";
    return fetch(url).then((res)=>res.json());
};
const AsyncAutocompleteRemoteRegions = (param)=>{
    let { id , cN , value , setValue  } = param;
    const [open, setOpen] = react.useState(false);
    const [options, setOptions] = react.useState([]);
    const { isLoading  } = (0,es.useQuery)([
        "remoteRegions"
    ], fetchRemoteRegions, {
        onSuccess: (data)=>{
            const sortedOptions = data.sort((a, b)=>a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
            setOptions(sortedOptions);
        }
    });
    return isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spinners.BeatLoader, {
        size: 8,
        margin: 2,
        color: "#aaa"
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
        multiple: true,
        id: id,
        classes: {
            inputFocused: "focus:ring-0"
        },
        open: open,
        onOpen: ()=>{
            setOpen(true);
        },
        onClose: ()=>{
            setOpen(false);
        },
        value: value,
        onChange: (_, value)=>{
            const ids = value.map((option)=>typeof option === "string" ? option : option.id);
            setValue(ids);
        },
        options: options.map((option)=>option.id),
        groupBy: (option)=>option.country,
        getOptionLabel: (option)=>{
            var ref;
            return (ref = options.find((o)=>o.id === option)) === null || ref === void 0 ? void 0 : ref.name;
        },
        isOptionEqualToValue: (option, value)=>{
            return option === value;
        },
        loading: isLoading,
        filterSelectedOptions: true,
        PaperComponent: (param)=>/*#__PURE__*/ {
            let { children  } = param;
            return (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                // This is to work together with SearchFields UI, specifically not to trigger onclickoutside which would close the UI instead of selecting the value
                // More: https://www.npmjs.com/package/react-cool-onclickoutside#user-content-ignore-elements-by-css-class-name
                className: "ignore-onclickoutside",
                children: children
            });
        },
        renderInput: (params)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                ...params,
                placeholder: "e.g. UTC-6 or European Union",
                className: "",
                InputProps: {
                    ...params.InputProps,
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spinners.BeatLoader, {
                                size: 8,
                                margin: 2,
                                color: "#aaa"
                            }) : null,
                            params.InputProps.endAdornment
                        ]
                    })
                }
            });
        }
    });
};

// EXTERNAL MODULE: ./types/tags.ts
var types_tags = __webpack_require__(75474);
// EXTERNAL MODULE: ./components/TagsGroup/TagsGroup.tsx
var TagsGroup = __webpack_require__(39371);
;// CONCATENATED MODULE: ./components/JobPost/editor/sections/LocationSection.tsx










// dynamic import
const PlacesAutocomplete = dynamic_default()(()=>__webpack_require__.e(/* import() */ 3342).then(__webpack_require__.bind(__webpack_require__, 53342)).then((module)=>{
        return module.PlacesAutocomplete;
    }), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(53342)
            ]
    }
});
const LocationSection = (param)=>{
    let { tags  } = param;
    // form
    const { watch , getValues , setValue , register , control , formState: { errors  }  } = (0,index_esm/* useFormContext */.Gc)();
    // ONSITE
    const hasLocations = watch("jobPost.hasLocations");
    const locations = watch("jobPost.locations");
    // REMOTE
    const hasRemote = watch("jobPost.hasRemote");
    const jobPost = getValues("jobPost");
    const remoteType = watch("jobPost.remote.type");
    const remoteRegions = watch("jobPost.remote.regions");
    const remoteRequirementsTypeSettings = [
        {
            name: "Not available.",
            value: client_index_browser.JobPostRemoteType.NONE
        },
        {
            name: "Available Worldwide.",
            value: client_index_browser.JobPostRemoteType.WORLDWIDE
        },
        {
            name: "Available in selected countries or time zones.",
            value: client_index_browser.JobPostRemoteType.SELECTED_REGIONS
        }
    ];
    // methods
    const addLocation = ()=>{
        const ts = new Date().getTime();
        const newLocations = [
            ...locations ? locations : [],
            {
                id: "new-".concat(ts),
                address: ""
            }
        ];
        setValue("jobPost.locations", newLocations);
    };
    const updateLocation = (id, location)=>{
        const newLocations = locations.map((l)=>{
            if (l.id === id) {
                return {
                    ...l,
                    ...location
                };
            }
            return l;
        });
        setValue("jobPost.locations", newLocations);
    };
    const removeLocation = (id)=>{
        const newLocations = locations.filter((location)=>location.id !== id);
        setValue("jobPost.locations", newLocations);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobPostEditorSectionLayout, {
        title: "Onsite / Remote",
        description: "Provide workplace location(s). If the job is fully remote, you can list the HQ location if there is one.",
        hasToggle: true,
        isToggled: hasLocations,
        onToggle: ()=>setValue("jobPost.hasLocations", !hasLocations),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mb-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsGroup/* TagsGroup */.Y, {
                    heading: "Does any of this apply?",
                    availableTagTypes: [
                        types_tags/* TagType.COMPENSATION_BENEFIT */.Q.COMPENSATION_BENEFIT,
                        types_tags/* TagType.ORGANISATION */.Q.ORGANISATION
                    ],
                    tags: tags.filter((t)=>[
                            "remote-first",
                            "paid-relocation",
                            "visa-sponsorship"
                        ].includes(t.id)),
                    name: "jobPost.userAssignedTags"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "p-4 bg-gray-50 border rounded-md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4 text-sm font-bold uppercase",
                        children: "Onsite location"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(GoogleMapsApiProvider, {
                        children: [
                            (locations === null || locations === void 0 ? void 0 : locations.length) > 0 ? locations === null || locations === void 0 ? void 0 : locations.map((loc, index)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "pb-4",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                            htmlFor: "jobPost.locations.address",
                                            className: "block text-sm font-medium text-gray-700",
                                            children: [
                                                "Location #",
                                                index + 1
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-row justify-start items-start",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlacesAutocomplete, {
                                                    name: loc.id,
                                                    defaultValue: (loc === null || loc === void 0 ? void 0 : loc.address) || "",
                                                    control: control,
                                                    cN: "relative w-full z-10",
                                                    inputCN: "mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                                    optionsCN: "mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm",
                                                    optionCN: "hover:text-white hover:bg-blue-600 cursor-default select-none relative py-2 pl-3 pr-9",
                                                    onSubmit: (value)=>{
                                                        updateLocation(loc.id, {
                                                            address: value
                                                        });
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    className: "m-2 p-1 text-xxs font-semibold uppercase text-gray-400 underline",
                                                    type: "button",
                                                    onClick: ()=>removeLocation(loc.id),
                                                    children: "remove"
                                                })
                                            ]
                                        })
                                    ]
                                }, loc.id);
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "px-2 py-1 text-xxs font-semibold uppercase text-blue-600 border border-blue-600 rounded hover:bg-blue-100",
                                type: "button",
                                onClick: addLocation,
                                children: "Add onsite location"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "mt-6 p-4 bg-gray-50 border rounded-md",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mb-4 text-sm font-bold uppercase",
                        children: "Remote available?"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("fieldset", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "space-y-4",
                            children: remoteRequirementsTypeSettings.map((setting)=>{
                                var ref;
                                /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                    className: "flex items-center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                            id: setting.value,
                                            name: "remoteRequirementsType",
                                            type: "radio",
                                            defaultChecked: setting.value === (jobPost === null || jobPost === void 0 ? void 0 : (ref = jobPost.remote) === null || ref === void 0 ? void 0 : ref.type),
                                            className: "focus:ring-blue-500 h-4 w-4 text-blue-600 border-gray-300",
                                            onClick: ()=>setValue("jobPost.remote.type", setting.value)
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                            htmlFor: setting.value,
                                            className: "ml-3 block text font-medium text-gray-700",
                                            children: setting.name
                                        })
                                    ]
                                }, setting.value);
                            })
                        })
                    }),
                    remoteType === client_index_browser.JobPostRemoteType.SELECTED_REGIONS && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex flex-row space-x-2 pt-4 pl-7",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "bg-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncAutocompleteRemoteRegions, {
                                    id: "jobPost.remote.regions",
                                    value: remoteRegions,
                                    setValue: (value)=>setValue("jobPost.remote.regions", value)
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/Form/Input.tsx
var Input = __webpack_require__(27778);
;// CONCATENATED MODULE: ./components/JobPost/editor/sections/ApplySection.tsx





const ApplySection = (param)=>{
    let { isLast  } = param;
    const { register , formState: { errors  }  } = (0,index_esm/* useFormContext */.Gc)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostEditorSectionLayout, {
        title: "How to Apply",
        description: "Link where to redirect the applicants.",
        isLast: isLast,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                label: "URL",
                path: "jobPost.applyUrl",
                register: register,
                errors: errors
            })
        })
    });
};

// EXTERNAL MODULE: ./components/Form/Select.tsx
var Select = __webpack_require__(65447);
// EXTERNAL MODULE: ./utils/enumToLabel/compensationUnitToLabel.ts
var compensationUnitToLabel = __webpack_require__(22536);
;// CONCATENATED MODULE: ./data/currencies.ts
const currencies = {
    AED: "United Arab Emirates Dirham",
    AFN: "Afghan Afghani",
    ALL: "Albanian Lek",
    AMD: "Armenian Dram",
    ANG: "Netherlands Antillean Guilder",
    AOA: "Angolan Kwanza",
    ARS: "Argentine Peso",
    AUD: "Australian Dollar",
    AWG: "Aruban Florin",
    AZN: "Azerbaijani Manat",
    BAM: "Bosnia-Herzegovina Convertible Mark",
    BBD: "Barbadian Dollar",
    BDT: "Bangladeshi Taka",
    BGN: "Bulgarian Lev",
    BHD: "Bahraini Dinar",
    BIF: "Burundian Franc",
    BMD: "Bermudan Dollar",
    BND: "Brunei Dollar",
    BOB: "Bolivian Boliviano",
    BRL: "Brazilian Real",
    BSD: "Bahamian Dollar",
    BTC: "Bitcoin",
    BTN: "Bhutanese Ngultrum",
    BWP: "Botswanan Pula",
    BYN: "Belarusian Ruble",
    BZD: "Belize Dollar",
    CAD: "Canadian Dollar",
    CDF: "Congolese Franc",
    CHF: "Swiss Franc",
    CLF: "Chilean Unit of Account (UF)",
    CLP: "Chilean Peso",
    CNH: "Chinese Yuan (Offshore)",
    CNY: "Chinese Yuan",
    COP: "Colombian Peso",
    CRC: "Costa Rican Col\xf3n",
    CUC: "Cuban Convertible Peso",
    CUP: "Cuban Peso",
    CVE: "Cape Verdean Escudo",
    CZK: "Czech Republic Koruna",
    DJF: "Djiboutian Franc",
    DKK: "Danish Krone",
    DOP: "Dominican Peso",
    DZD: "Algerian Dinar",
    EGP: "Egyptian Pound",
    ERN: "Eritrean Nakfa",
    ETB: "Ethiopian Birr",
    EUR: "Euro",
    FJD: "Fijian Dollar",
    FKP: "Falkland Islands Pound",
    GBP: "British Pound Sterling",
    GEL: "Georgian Lari",
    GGP: "Guernsey Pound",
    GHS: "Ghanaian Cedi",
    GIP: "Gibraltar Pound",
    GMD: "Gambian Dalasi",
    GNF: "Guinean Franc",
    GTQ: "Guatemalan Quetzal",
    GYD: "Guyanaese Dollar",
    HKD: "Hong Kong Dollar",
    HNL: "Honduran Lempira",
    HRK: "Croatian Kuna",
    HTG: "Haitian Gourde",
    HUF: "Hungarian Forint",
    IDR: "Indonesian Rupiah",
    ILS: "Israeli New Sheqel",
    IMP: "Manx pound",
    INR: "Indian Rupee",
    IQD: "Iraqi Dinar",
    IRR: "Iranian Rial",
    ISK: "Icelandic Kr\xf3na",
    JEP: "Jersey Pound",
    JMD: "Jamaican Dollar",
    JOD: "Jordanian Dinar",
    JPY: "Japanese Yen",
    KES: "Kenyan Shilling",
    KGS: "Kyrgystani Som",
    KHR: "Cambodian Riel",
    KMF: "Comorian Franc",
    KPW: "North Korean Won",
    KRW: "South Korean Won",
    KWD: "Kuwaiti Dinar",
    KYD: "Cayman Islands Dollar",
    KZT: "Kazakhstani Tenge",
    LAK: "Laotian Kip",
    LBP: "Lebanese Pound",
    LKR: "Sri Lankan Rupee",
    LRD: "Liberian Dollar",
    LSL: "Lesotho Loti",
    LYD: "Libyan Dinar",
    MAD: "Moroccan Dirham",
    MDL: "Moldovan Leu",
    MGA: "Malagasy Ariary",
    MKD: "Macedonian Denar",
    MMK: "Myanma Kyat",
    MNT: "Mongolian Tugrik",
    MOP: "Macanese Pataca",
    MRU: "Mauritanian Ouguiya",
    MUR: "Mauritian Rupee",
    MVR: "Maldivian Rufiyaa",
    MWK: "Malawian Kwacha",
    MXN: "Mexican Peso",
    MYR: "Malaysian Ringgit",
    MZN: "Mozambican Metical",
    NAD: "Namibian Dollar",
    NGN: "Nigerian Naira",
    NIO: "Nicaraguan C\xf3rdoba",
    NOK: "Norwegian Krone",
    NPR: "Nepalese Rupee",
    NZD: "New Zealand Dollar",
    OMR: "Omani Rial",
    PAB: "Panamanian Balboa",
    PEN: "Peruvian Nuevo Sol",
    PGK: "Papua New Guinean Kina",
    PHP: "Philippine Peso",
    PKR: "Pakistani Rupee",
    PLN: "Polish Zloty",
    PYG: "Paraguayan Guarani",
    QAR: "Qatari Rial",
    RON: "Romanian Leu",
    RSD: "Serbian Dinar",
    RUB: "Russian Ruble",
    RWF: "Rwandan Franc",
    SAR: "Saudi Riyal",
    SBD: "Solomon Islands Dollar",
    SCR: "Seychellois Rupee",
    SDG: "Sudanese Pound",
    SEK: "Swedish Krona",
    SGD: "Singapore Dollar",
    SHP: "Saint Helena Pound",
    SLL: "Sierra Leonean Leone",
    SOS: "Somali Shilling",
    SRD: "Surinamese Dollar",
    SSP: "South Sudanese Pound",
    STD: "S\xe3o Tom\xe9 and Pr\xedncipe Dobra (pre-2018)",
    STN: "S\xe3o Tom\xe9 and Pr\xedncipe Dobra",
    SVC: "Salvadoran Col\xf3n",
    SYP: "Syrian Pound",
    SZL: "Swazi Lilangeni",
    THB: "Thai Baht",
    TJS: "Tajikistani Somoni",
    TMT: "Turkmenistani Manat",
    TND: "Tunisian Dinar",
    TOP: "Tongan Pa'anga",
    TRY: "Turkish Lira",
    TTD: "Trinidad and Tobago Dollar",
    TWD: "New Taiwan Dollar",
    TZS: "Tanzanian Shilling",
    UAH: "Ukrainian Hryvnia",
    UGX: "Ugandan Shilling",
    USD: "United States Dollar",
    UYU: "Uruguayan Peso",
    UZS: "Uzbekistan Som",
    VEF: "Venezuelan Bol\xedvar Fuerte (Old)",
    VES: "Venezuelan Bol\xedvar Soberano",
    VND: "Vietnamese Dong",
    VUV: "Vanuatu Vatu",
    WST: "Samoan Tala",
    XAF: "CFA Franc BEAC",
    XAG: "Silver Ounce",
    XAU: "Gold Ounce",
    XCD: "East Caribbean Dollar",
    XDR: "Special Drawing Rights",
    XOF: "CFA Franc BCEAO",
    XPD: "Palladium Ounce",
    XPF: "CFP Franc",
    XPT: "Platinum Ounce",
    YER: "Yemeni Rial",
    ZAR: "South African Rand",
    ZMW: "Zambian Kwacha",
    ZWL: "Zimbabwean Dollar"
};

;// CONCATENATED MODULE: ./components/JobPost/editor/sections/CompensationSection.tsx












const CompensationSection = (param)=>{
    let { tags  } = param;
    const { watch , setValue , register , formState: { errors  }  } = (0,index_esm/* useFormContext */.Gc)();
    const hasCompensation = watch("jobPost.hasCompensation");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobPostEditorSectionLayout, {
        title: "Compensation & Benefits",
        description: "Provide salary details & any extras like stock options etc. Job posts with compensation rank higher in search results.",
        hasToggle: true,
        isToggled: hasCompensation,
        onToggle: ()=>setValue("jobPost.hasCompensation", !hasCompensation),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-row space-x-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                            label: "Currency",
                            path: "jobPost.compensation.currency",
                            options: [
                                client_index_browser.CurrencyCode.USD,
                                client_index_browser.CurrencyCode.GBP,
                                client_index_browser.CurrencyCode.EUR,
                                client_index_browser.CurrencyCode.CNY,
                                ...Object.keys(currencies).filter((c)=>![
                                        client_index_browser.CurrencyCode.USD,
                                        client_index_browser.CurrencyCode.GBP,
                                        client_index_browser.CurrencyCode.EUR,
                                        client_index_browser.CurrencyCode.CNY
                                    ].includes(c))
                            ].map((type, i)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("option", {
                                    value: type,
                                    className: (0,classNames/* classNames */.A)(i === 3 ? "border-t" : ""),
                                    children: [
                                        type,
                                        " - ",
                                        currencies[type]
                                    ]
                                }, type)),
                            register: register,
                            defaultValue: client_index_browser.CurrencyCode.USD,
                            errors: errors
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Select/* Select */.P, {
                            label: "Unit",
                            path: "jobPost.compensation.unit",
                            options: [
                                client_index_browser.CompensationUnit.HOUR,
                                client_index_browser.CompensationUnit.DAY,
                                client_index_browser.CompensationUnit.WEEK,
                                client_index_browser.CompensationUnit.MONTH,
                                client_index_browser.CompensationUnit.YEAR
                            ].map((type)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    value: type,
                                    children: compensationUnitToLabel/* compensationUnitToLabel */.W[type]
                                }, type)),
                            register: register,
                            errors: errors
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                            label: "Min",
                            hasOptionalBadge: true,
                            path: "jobPost.compensation.min",
                            placeholder: "30000",
                            register: register,
                            registerOptions: {
                                setValueAs: (v)=>parseInt(v) !== NaN ? parseFloat(v) : null
                            },
                            errors: errors
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-span-6",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                            label: "Max",
                            path: "jobPost.compensation.max",
                            placeholder: "50000",
                            register: register,
                            registerOptions: {
                                setValueAs: (v)=>parseInt(v) !== NaN ? parseFloat(v) : null
                            },
                            errors: errors
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-6 sm:col-span-6 lg:col-span-2 mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsGroup/* TagsGroup */.Y, {
                    heading: "Benefits",
                    availableTagTypes: [
                        types_tags/* TagType.COMPENSATION_BENEFIT */.Q.COMPENSATION_BENEFIT,
                        types_tags/* TagType.JOB */.Q.JOB
                    ],
                    tags: tags,
                    name: "jobPost.userAssignedTags"
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./config/config.client.ts
var config_client = __webpack_require__(39223);
;// CONCATENATED MODULE: ./components/AsyncAutocomplete/AsyncAutocompleteOrganisations.tsx










const AsyncAutocompleteOrganisations = (param)=>{
    let { id , cN , value , setValue  } = param;
    const [open, setOpen] = react.useState(false);
    const [options, setOptions] = react.useState([]);
    const [searchValue, setSearchValue] = react.useState("");
    // Fetch organisations. (based on search params)
    const fetchOrganisations = async ()=>{
        const url = "/api/organisations/search?name=".concat(searchValue);
        return fetch(url).then((res)=>res.json());
    };
    const { isLoading  } = (0,es.useQuery)([
        "organisations",
        searchValue
    ], fetchOrganisations, {
        onSuccess: (data)=>{
            const sortedOptions = data.organisations.sort((a, b)=>a.name < b.name ? -1 : a.name > b.name ? 1 : 0);
            const sortedOptionsWithAddNewOrganisation = [
                ...sortedOptions,
                {
                    id: "",
                    name: 'Add "'.concat(searchValue, '"'),
                    isAddNew: true,
                    searchValue
                }
            ];
            const newOptions = data.length === config_client/* ORGANISATIONS_AUTOCOMPLETE_LIMIT */.DQ ? sortedOptions : sortedOptionsWithAddNewOrganisation;
            setOptions(newOptions);
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Autocomplete/* default */.Z, {
        multiple: false,
        id: id,
        classes: {
            inputFocused: "focus:ring-0",
            listbox: "border"
        },
        open: open,
        onOpen: ()=>{
            setOpen(true);
        },
        onClose: ()=>{
            setOpen(false);
        },
        value: value,
        onChange: (_, value)=>{
            if (value === null || value === void 0 ? void 0 : value.isAddNew) {
                setValue({
                    id: "",
                    name: value.searchValue
                });
            } else {
                setValue(value);
            }
        },
        options: options,
        //   groupBy={(option) => option.country}
        //   noOptionsText={() => (
        //     <div
        //       onClick={() => {
        //         console.log("clicked");
        //       }}
        //     >
        //       Create new
        //     </div>
        //   )}
        freeSolo: true,
        getOptionLabel: (option)=>option.name || "",
        renderOption: (props, option)=>{
            /*#__PURE__*/ return (0,react.createElement)("li", {
                ...props,
                key: option.id,
                className: "flex p-2 hover:bg-gray-100",
                children: [
                    option.favicon ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        className: "mr-4 rounded w-5 h-5",
                        width: 18,
                        height: 18,
                        src: "".concat("https://xxshqbqasrbviwgjwzwp.supabase.co", "/storage/v1/object/public/public").concat(option === null || option === void 0 ? void 0 : option.favicon),
                        alt: "".concat((option === null || option === void 0 ? void 0 : option.name) || "", " logo")
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: option.name
                    })
                ]
            });
        },
        isOptionEqualToValue: (option, value)=>{
            return option === value;
        },
        loading: isLoading,
        filterSelectedOptions: true,
        PaperComponent: (param)=>/*#__PURE__*/ {
            let { children  } = param;
            return (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                // This is to work together with SearchFields UI, specifically not to trigger onclickoutside which would close the UI instead of selecting the value
                // More: https://www.npmjs.com/package/react-cool-onclickoutside#user-content-ignore-elements-by-css-class-name
                className: "ignore-onclickoutside",
                children: children
            });
        },
        renderInput: (params)=>{
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                ...params,
                placeholder: "Company name",
                className: "",
                onChange: (e)=>{
                    setSearchValue(e.target.value);
                },
                InputProps: {
                    ...params.InputProps,
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spinners.BeatLoader, {
                                size: 8,
                                margin: 2,
                                color: "#aaa"
                            }) : null,
                            params.InputProps.endAdornment
                        ]
                    })
                }
            });
        }
    });
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/XMarkIcon.js
var XMarkIcon = __webpack_require__(96445);
;// CONCATENATED MODULE: ./components/JobPost/editor/sections/HiringOrganisationSection.tsx








const HiringOrganisationSection = ()=>{
    const { watch , setValue , register , formState: { errors  }  } = (0,index_esm/* useFormContext */.Gc)();
    const hasHiringOrganisation = watch("jobPost.hasHiringOrganisation");
    const jobPostHiringOrganisation = watch("jobPost.hiringOrganisation");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostEditorSectionLayout, {
        title: "Company",
        description: "Information about the hiring company.",
        hasToggle: true,
        isToggled: hasHiringOrganisation,
        onToggle: ()=>setValue("jobPost.hasHiringOrganisation", !hasHiringOrganisation),
        children: jobPostHiringOrganisation ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative p-4 bg-blue-50 border border-blue-200 rounded-md",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    className: "absolute top-4 right-4 px-1 py-1 text-xs bg-transparent rounded",
                    onClick: ()=>setValue("jobPost.hiringOrganisation", null),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(XMarkIcon/* default */.Z, {
                        className: "w-4 h-4 text-black"
                    })
                }),
                jobPostHiringOrganisation.id ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex flex-row",
                    children: [
                        jobPostHiringOrganisation.favicon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mr-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                className: "rounded",
                                width: 48,
                                height: 48,
                                src: "".concat("https://xxshqbqasrbviwgjwzwp.supabase.co", "/storage/v1/object/public/public").concat(jobPostHiringOrganisation === null || jobPostHiringOrganisation === void 0 ? void 0 : jobPostHiringOrganisation.favicon),
                                alt: "".concat((jobPostHiringOrganisation === null || jobPostHiringOrganisation === void 0 ? void 0 : jobPostHiringOrganisation.name) || "", " logo")
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "font-bold",
                                    children: [
                                        jobPostHiringOrganisation.name,
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-sm",
                                    children: jobPostHiringOrganisation.webUrl
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "mt-4",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                label: "Name",
                                hasOptionalBadge: true,
                                path: "jobPost.hiringOrganisation.name",
                                placeholder: "Hiring company name",
                                register: register,
                                errors: errors
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-6 mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                label: "About (short)",
                                hasOptionalBadge: true,
                                path: "jobPost.hiringOrganisation.about",
                                placeholder: "Your company mission in less than 200 characters.",
                                register: register,
                                errors: errors
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-6 mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                label: "Website",
                                hasOptionalBadge: true,
                                path: "jobPost.hiringOrganisation.webUrl",
                                register: register,
                                errors: errors
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-6 mt-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                label: "Twitter",
                                hasOptionalBadge: true,
                                path: "jobPost.hiringOrganisation.twitterUrl",
                                register: register,
                                registerOptions: {
                                    prefix: "hello"
                                },
                                errors: errors
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-6 mt-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                label: "LinkedIn",
                                hasOptionalBadge: true,
                                path: "jobPost.hiringOrganisation.linkedinUrl",
                                register: register,
                                errors: errors
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-span-6 mt-3",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                                label: "GitHub",
                                hasOptionalBadge: true,
                                path: "jobPost.hiringOrganisation.githubUrl",
                                register: register,
                                errors: errors
                            })
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AsyncAutocompleteOrganisations, {
                id: "hiringOrganisation",
                value: (jobPostHiringOrganisation === null || jobPostHiringOrganisation === void 0 ? void 0 : jobPostHiringOrganisation.id) || null,
                setValue: (organisation)=>{
                    setValue("jobPost.hiringOrganisation", organisation);
                }
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@tiptap/react/dist/tiptap-react.esm.js + 3 modules
var tiptap_react_esm = __webpack_require__(20255);
// EXTERNAL MODULE: ./node_modules/@tiptap/starter-kit/dist/tiptap-starter-kit.esm.js + 22 modules
var tiptap_starter_kit_esm = __webpack_require__(96147);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-link/dist/tiptap-extension-link.esm.js + 1 modules
var tiptap_extension_link_esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-highlight/dist/tiptap-extension-highlight.esm.js
var tiptap_extension_highlight_esm = __webpack_require__(34524);
;// CONCATENATED MODULE: ./public/remixicon/16px/bold.svg
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgBold = function SvgBold(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M8 11h4.5a2.5 2.5 0 1 0 0-5H8v5zm10 4.5a4.5 4.5 0 0 1-4.5 4.5H6V4h6.5a4.5 4.5 0 0 1 3.256 7.606A4.498 4.498 0 0 1 18 15.5zM8 13v5h5.5a2.5 2.5 0 1 0 0-5H8z"
  })));
};
/* harmony default export */ var bold = (SvgBold);
;// CONCATENATED MODULE: ./public/remixicon/16px/italic.svg
var italic_path, italic_path2;
function italic_extends() { italic_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return italic_extends.apply(this, arguments); }

var SvgItalic = function SvgItalic(props) {
  return /*#__PURE__*/react.createElement("svg", italic_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), italic_path || (italic_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), italic_path2 || (italic_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M15 20H7v-2h2.927l2.116-12H9V4h8v2h-2.927l-2.116 12H15z"
  })));
};
/* harmony default export */ var italic = (SvgItalic);
;// CONCATENATED MODULE: ./public/remixicon/16px/h-1.svg
var h_1_path, h_1_path2;
function h_1_extends() { h_1_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return h_1_extends.apply(this, arguments); }

var SvgH1 = function SvgH1(props) {
  return /*#__PURE__*/react.createElement("svg", h_1_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), h_1_path || (h_1_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), h_1_path2 || (h_1_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M13 20h-2v-7H4v7H2V4h2v7h7V4h2v16zm8-12v12h-2v-9.796l-2 .536V8.67L19.5 8H21z"
  })));
};
/* harmony default export */ var h_1 = (SvgH1);
;// CONCATENATED MODULE: ./public/remixicon/16px/h-2.svg
var h_2_path, h_2_path2;
function h_2_extends() { h_2_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return h_2_extends.apply(this, arguments); }

var SvgH2 = function SvgH2(props) {
  return /*#__PURE__*/react.createElement("svg", h_2_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), h_2_path || (h_2_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), h_2_path2 || (h_2_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M4 4v7h7V4h2v16h-2v-7H4v7H2V4h2zm14.5 4a3.75 3.75 0 0 1 2.978 6.03l-.148.18L18.034 18H22v2h-7v-1.556l4.82-5.546a1.75 1.75 0 1 0-3.064-1.292l-.006.144h-2A3.75 3.75 0 0 1 18.5 8z"
  })));
};
/* harmony default export */ var h_2 = (SvgH2);
;// CONCATENATED MODULE: ./public/remixicon/16px/h-3.svg
var h_3_path, h_3_path2;
function h_3_extends() { h_3_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return h_3_extends.apply(this, arguments); }

var SvgH3 = function SvgH3(props) {
  return /*#__PURE__*/react.createElement("svg", h_3_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), h_3_path || (h_3_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), h_3_path2 || (h_3_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m22 8-.002 2-2.505 2.883a3.75 3.75 0 1 1-4.675 4.334l1.964-.382a1.75 1.75 0 1 0 .924-1.895l-1.307-1.547L19.35 10H15V8h7zM4 4v7h7V4h2v16h-2v-7H4v7H2V4h2z"
  })));
};
/* harmony default export */ var h_3 = (SvgH3);
;// CONCATENATED MODULE: ./public/remixicon/16px/parking-line.svg
var parking_line_path, parking_line_path2;
function parking_line_extends() { parking_line_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return parking_line_extends.apply(this, arguments); }

var SvgParkingLine = function SvgParkingLine(props) {
  return /*#__PURE__*/react.createElement("svg", parking_line_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), parking_line_path || (parking_line_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), parking_line_path2 || (parking_line_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M6 3h7a6 6 0 1 1 0 12H8v6H6V3zm2 2v8h5a4 4 0 1 0 0-8H8z"
  })));
};
/* harmony default export */ var parking_line = (SvgParkingLine);
;// CONCATENATED MODULE: ./public/remixicon/16px/link.svg
var link_path, link_path2;
function link_extends() { link_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return link_extends.apply(this, arguments); }

var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/react.createElement("svg", link_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), link_path || (link_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), link_path2 || (link_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M18.364 15.536 16.95 14.12l1.414-1.414a5 5 0 1 0-7.071-7.071L9.879 7.05 8.464 5.636 9.88 4.222a7 7 0 0 1 9.9 9.9l-1.415 1.414zm-2.828 2.828-1.415 1.414a7 7 0 0 1-9.9-9.9l1.415-1.414L7.05 9.88l-1.414 1.414a5 5 0 1 0 7.071 7.071l1.414-1.414 1.415 1.414zm-.708-10.607 1.415 1.415-7.071 7.07-1.415-1.414 7.071-7.07z"
  })));
};
/* harmony default export */ var _16px_link = (SvgLink);
;// CONCATENATED MODULE: ./public/remixicon/16px/list-ordered.svg
var list_ordered_path, list_ordered_path2;
function list_ordered_extends() { list_ordered_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return list_ordered_extends.apply(this, arguments); }

var SvgListOrdered = function SvgListOrdered(props) {
  return /*#__PURE__*/react.createElement("svg", list_ordered_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), list_ordered_path || (list_ordered_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), list_ordered_path2 || (list_ordered_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M8 4h13v2H8V4zM5 3v3h1v1H3V6h1V4H3V3h2zM3 14v-2.5h2V11H3v-1h3v2.5H4v.5h2v1H3zm2 5.5H3v-1h2V18H3v-1h3v4H3v-1h2v-.5zM8 11h13v2H8v-2zm0 7h13v2H8v-2z"
  })));
};
/* harmony default export */ var list_ordered = (SvgListOrdered);
;// CONCATENATED MODULE: ./public/remixicon/16px/list-unordered.svg
var list_unordered_path, list_unordered_path2;
function list_unordered_extends() { list_unordered_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return list_unordered_extends.apply(this, arguments); }

var SvgListUnordered = function SvgListUnordered(props) {
  return /*#__PURE__*/react.createElement("svg", list_unordered_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), list_unordered_path || (list_unordered_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), list_unordered_path2 || (list_unordered_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M8 4h13v2H8V4zM4.5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 6.9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zM8 11h13v2H8v-2zm0 7h13v2H8v-2z"
  })));
};
/* harmony default export */ var list_unordered = (SvgListUnordered);
;// CONCATENATED MODULE: ./public/remixicon/16px/separator.svg
var separator_path, separator_path2;
function separator_extends() { separator_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return separator_extends.apply(this, arguments); }

var SvgSeparator = function SvgSeparator(props) {
  return /*#__PURE__*/react.createElement("svg", separator_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), separator_path || (separator_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), separator_path2 || (separator_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M2 11h2v2H2v-2zm4 0h12v2H6v-2zm14 0h2v2h-2v-2z"
  })));
};
/* harmony default export */ var separator = (SvgSeparator);
;// CONCATENATED MODULE: ./public/remixicon/16px/code-s-slash-line.svg
var code_s_slash_line_path, code_s_slash_line_path2;
function code_s_slash_line_extends() { code_s_slash_line_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return code_s_slash_line_extends.apply(this, arguments); }

var SvgCodeSSlashLine = function SvgCodeSSlashLine(props) {
  return /*#__PURE__*/react.createElement("svg", code_s_slash_line_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), code_s_slash_line_path || (code_s_slash_line_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), code_s_slash_line_path2 || (code_s_slash_line_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m24 12-5.657 5.657-1.414-1.414L21.172 12l-4.243-4.243 1.414-1.414L24 12zM2.828 12l4.243 4.243-1.414 1.414L0 12l5.657-5.657L7.07 7.757 2.828 12zm6.96 9H7.66l6.552-18h2.128L9.788 21z"
  })));
};
/* harmony default export */ var code_s_slash_line = (SvgCodeSSlashLine);
;// CONCATENATED MODULE: ./public/remixicon/16px/code-box-line.svg
var code_box_line_path, code_box_line_path2;
function code_box_line_extends() { code_box_line_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return code_box_line_extends.apply(this, arguments); }

var SvgCodeBoxLine = function SvgCodeBoxLine(props) {
  return /*#__PURE__*/react.createElement("svg", code_box_line_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), code_box_line_path || (code_box_line_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), code_box_line_path2 || (code_box_line_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M3 3h18a1 1 0 0 1 1 1v16a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm1 2v14h16V5H4zm16 7-3.536 3.536-1.414-1.415L17.172 12 15.05 9.879l1.414-1.415L20 12zM6.828 12l2.122 2.121-1.414 1.415L4 12l3.536-3.536L8.95 9.88 6.828 12zm4.416 5H9.116l3.64-10h2.128l-3.64 10z"
  })));
};
/* harmony default export */ var code_box_line = (SvgCodeBoxLine);
;// CONCATENATED MODULE: ./public/remixicon/16px/arrow-go-back-line.svg
var arrow_go_back_line_path, arrow_go_back_line_path2;
function arrow_go_back_line_extends() { arrow_go_back_line_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_go_back_line_extends.apply(this, arguments); }

var SvgArrowGoBackLine = function SvgArrowGoBackLine(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_go_back_line_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), arrow_go_back_line_path || (arrow_go_back_line_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), arrow_go_back_line_path2 || (arrow_go_back_line_path2 = /*#__PURE__*/react.createElement("path", {
    d: "m5.828 7 2.536 2.536L6.95 10.95 2 6l4.95-4.95 1.414 1.414L5.828 5H13a8 8 0 1 1 0 16H4v-2h9a6 6 0 1 0 0-12H5.828z"
  })));
};
/* harmony default export */ var arrow_go_back_line = (SvgArrowGoBackLine);
;// CONCATENATED MODULE: ./public/remixicon/16px/arrow-go-forward-line.svg
var arrow_go_forward_line_path, arrow_go_forward_line_path2;
function arrow_go_forward_line_extends() { arrow_go_forward_line_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return arrow_go_forward_line_extends.apply(this, arguments); }

var SvgArrowGoForwardLine = function SvgArrowGoForwardLine(props) {
  return /*#__PURE__*/react.createElement("svg", arrow_go_forward_line_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), arrow_go_forward_line_path || (arrow_go_forward_line_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), arrow_go_forward_line_path2 || (arrow_go_forward_line_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M18.172 7H11a6 6 0 1 0 0 12h9v2h-9a8 8 0 1 1 0-16h7.172l-2.536-2.536L17.05 1.05 22 6l-4.95 4.95-1.414-1.414L18.172 7z"
  })));
};
/* harmony default export */ var arrow_go_forward_line = (SvgArrowGoForwardLine);
;// CONCATENATED MODULE: ./public/remixicon/16px/format-clear.svg
var format_clear_path, format_clear_path2;
function format_clear_extends() { format_clear_extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return format_clear_extends.apply(this, arguments); }

var SvgFormatClear = function SvgFormatClear(props) {
  return /*#__PURE__*/react.createElement("svg", format_clear_extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: 16,
    height: 16
  }, props), format_clear_path || (format_clear_path = /*#__PURE__*/react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), format_clear_path2 || (format_clear_path2 = /*#__PURE__*/react.createElement("path", {
    d: "M12.651 14.065 11.605 20H9.574l1.35-7.661-7.41-7.41L4.93 3.515 20.485 19.07l-1.414 1.414-6.42-6.42zm-.878-6.535.27-1.53h-1.8l-2-2H20v2h-5.927L13.5 9.257 11.773 7.53z"
  })));
};
/* harmony default export */ var format_clear = (SvgFormatClear);
// EXTERNAL MODULE: ./node_modules/valid-url/index.js
var valid_url = __webpack_require__(80481);
;// CONCATENATED MODULE: ./utils/validation/isEmail.ts
const isEmail = (str)=>{
    const re = /\S+@\S+\.\S+/;
    return re.test(str);
};

;// CONCATENATED MODULE: ./components/TextEditor/MenuBar.tsx



















const MenuBar = (param)=>{
    let { editor  } = param;
    if (!editor) {
        return null;
    }
    const onLink = ()=>{
        const oldUrl = editor.getAttributes("link").href;
        const oldUrlCleansed = oldUrl === null || oldUrl === void 0 ? void 0 : oldUrl.replace("mailto:", "");
        console.log({
            oldUrl,
            oldUrlCleansed
        });
        let url;
        // !(url === "" || url === null || isValidWebUrl || isValidEmailUrl)
        while(true){
            url = window.prompt("Enter link or email", url || oldUrlCleansed);
            // is email?
            const isValidEmailUrl = isEmail(url);
            if (isValidEmailUrl) {
                url = "mailto:".concat(url);
                console.log("EMAIL", {
                    url,
                    isValidEmailUrl
                });
                break;
            }
            // is web link?
            const isValidWebUrl = !!(0,valid_url.isWebUri)(url);
            if (isValidWebUrl) {
                console.log("WEB LINK", {
                    url,
                    isValidWebUrl
                });
                break;
            }
            // const urlWithHardcodedSchema = `https://${url}`;
            // const isValidWebUrlWithoutSchema = !!isWebUri(urlWithHardcodedSchema);
            // if (isValidWebUrlWithoutSchema) {
            //   url = urlWithHardcodedSchema;
            //   console.log("WEB LINK WITHOUT SCHEMA", {
            //     url,
            //     isValidWebUrlWithoutSchema,
            //   });
            //   break;
            // }
            // is empty string or null?
            if (url === "" || url === null) {
                console.log("OTHER", {
                    url,
                    isValidEmailUrl,
                    isValidWebUrl
                });
                break;
            }
            console.log("INVALID", {
                url,
                isValidWebUrl
            });
            alert("Invalid url. Does it start with https:// ?");
        }
        // handle cancel -> value will be null
        if (url === null) {
            return;
        }
        // handle removing link -> value will be empty string
        if (url === "") {
            return editor.chain().focus().unsetLink().run();
        }
        // handle setting link -> value will be non-empty string
        if (!!url) {
            return editor.chain().focus().setLink({
                href: url
            }).run();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row divide-x divide-gray-200",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "bold",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleBold().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("bold") ? "bg-blue-100" : "hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bold, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("bold") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "italic",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleItalic().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("italic") ? "bg-blue-100" : "hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(italic, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("italic") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "heading 1",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleHeading({
                                level: 1
                            }).run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                            level: 1
                        }) ? "bg-blue-100" : "hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(h_1, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                                level: 1
                            }) ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "heading 2",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleHeading({
                                level: 2
                            }).run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                            level: 2
                        }) ? "bg-blue-100" : "hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(h_2, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                                level: 2
                            }) ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "heading 3",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleHeading({
                                level: 3
                            }).run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                            level: 3
                        }) ? "bg-blue-100" : "hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(h_3, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                                level: 3
                            }) ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "paragraph",
                        type: "button",
                        onClick: ()=>editor.chain().focus().setParagraph().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("paragraph") ? "bg-blue-100" : "hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(parking_line, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("paragraph") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "code block",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleCodeBlock().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("codeBlock") ? "bg-blue-100" : "hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(code_box_line, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("codeBlock") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "code",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleCode().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("code") ? "bg-blue-100" : "hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(code_s_slash_line, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("code") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "bullet list",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleBulletList().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("bulletList") ? "bg-blue-100" : "hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list_unordered, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("bulletList") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "ordered list",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleOrderedList().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("orderedList") ? "bg-blue-100" : "hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list_ordered, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("orderedList") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "link",
                        type: "button",
                        onClick: onLink,
                        className: (0,classNames/* classNames */.A)(editor.isActive("link") ? "bg-blue-100" : "hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_16px_link, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("link") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "horizontal rule",
                        type: "button",
                        onClick: ()=>editor.chain().focus().setHorizontalRule().run(),
                        className: (0,classNames/* classNames */.A)("hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(separator, {
                            className: "text-gray-600 fill-current"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "px-0.5",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    title: "clear formatting",
                    type: "button",
                    onClick: ()=>editor.chain().focus().clearNodes().unsetAllMarks().run(),
                    className: (0,classNames/* classNames */.A)("hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(format_clear, {
                        className: "text-gray-600 fill-current"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "px-0.5",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "undo",
                        type: "button",
                        onClick: ()=>editor.chain().focus().undo().run(),
                        className: (0,classNames/* classNames */.A)("hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_go_back_line, {
                            className: "text-gray-600 fill-current"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "redo",
                        type: "button",
                        onClick: ()=>editor.chain().focus().redo().run(),
                        className: (0,classNames/* classNames */.A)("hover:bg-gray-100", "px-2 py-2 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_go_forward_line, {
                            className: "text-gray-600 fill-current"
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/TextEditor/BubbleMenuBar.tsx













const BubbleMenuBar = (param)=>{
    let { editor  } = param;
    if (!editor) {
        return null;
    }
    const onLink = ()=>{
        const oldUrl = editor.getAttributes("link").href;
        const oldUrlCleansed = oldUrl === null || oldUrl === void 0 ? void 0 : oldUrl.replace("mailto:", "");
        console.log({
            oldUrl,
            oldUrlCleansed
        });
        let url;
        // !(url === "" || url === null || isValidWebUrl || isValidEmailUrl)
        while(true){
            url = window.prompt("Enter link or email", url || oldUrlCleansed);
            // is email?
            const isValidEmailUrl = isEmail(url);
            if (isValidEmailUrl) {
                url = "mailto:".concat(url);
                console.log("EMAIL", {
                    url,
                    isValidEmailUrl
                });
                break;
            }
            // is web link?
            const isValidWebUrl = !!(0,valid_url.isWebUri)(url);
            if (isValidWebUrl) {
                console.log("WEB LINK", {
                    url,
                    isValidWebUrl
                });
                break;
            }
            // const urlWithHardcodedSchema = `https://${url}`;
            // const isValidWebUrlWithoutSchema = !!isWebUri(urlWithHardcodedSchema);
            // if (isValidWebUrlWithoutSchema) {
            //   url = urlWithHardcodedSchema;
            //   console.log("WEB LINK WITHOUT SCHEMA", {
            //     url,
            //     isValidWebUrlWithoutSchema,
            //   });
            //   break;
            // }
            // is empty string or null?
            if (url === "" || url === null) {
                console.log("OTHER", {
                    url,
                    isValidEmailUrl,
                    isValidWebUrl
                });
                break;
            }
            console.log("INVALID", {
                url,
                isValidWebUrl
            });
            alert("Invalid url. Does it start with https:// ?");
        }
        // handle cancel -> value will be null
        if (url === null) {
            return;
        }
        // handle removing link -> value will be empty string
        if (url === "") {
            return editor.chain().focus().unsetLink().run();
        }
        // handle setting link -> value will be non-empty string
        if (!!url) {
            return editor.chain().focus().setLink({
                href: url
            }).run();
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row divide-x divide-gray-200 bg-white border border-gray-300 rounded-md shadow-md shadow-black/40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "bold",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleBold().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("bold") ? "bg-blue-100" : "hover:bg-gray-100", "px-1.5 py-1.5 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(bold, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("bold") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "italic",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleItalic().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("italic") ? "bg-blue-100" : "hover:bg-gray-100", "px-1.5 py-1.5 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(italic, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("italic") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "heading 1",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleHeading({
                                level: 1
                            }).run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                            level: 1
                        }) ? "bg-blue-100" : "hover:bg-gray-100", "px-1.5 py-1.5 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(h_1, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                                level: 1
                            }) ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "heading 2",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleHeading({
                                level: 2
                            }).run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                            level: 2
                        }) ? "bg-blue-100" : "hover:bg-gray-100", "px-1.5 py-1.5 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(h_2, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                                level: 2
                            }) ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "heading 3",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleHeading({
                                level: 3
                            }).run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                            level: 3
                        }) ? "bg-blue-100" : "hover:bg-gray-100", "px-1.5 py-1.5 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(h_3, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("heading", {
                                level: 3
                            }) ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "paragraph",
                        type: "button",
                        onClick: ()=>editor.chain().focus().setParagraph().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("paragraph") ? "bg-blue-100" : "hover:bg-gray-100", "px-1.5 py-1.5 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(parking_line, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("paragraph") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "bullet list",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleBulletList().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("bulletList") ? "bg-blue-100" : "hover:bg-gray-100", "px-1.5 py-1.5 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list_unordered, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("bulletList") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        title: "ordered list",
                        type: "button",
                        onClick: ()=>editor.chain().focus().toggleOrderedList().run(),
                        className: (0,classNames/* classNames */.A)(editor.isActive("orderedList") ? "bg-blue-100" : "hover:bg-gray-100", "px-1.5 py-1.5 m-px rounded"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list_ordered, {
                            className: (0,classNames/* classNames */.A)(editor.isActive("orderedList") ? "text-blue-600" : "text-gray-600", "fill-current")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                    title: "clear formatting",
                    type: "button",
                    onClick: ()=>editor.chain().focus().clearNodes().unsetAllMarks().run(),
                    className: (0,classNames/* classNames */.A)("hover:bg-gray-100", "px-1.5 py-1.5 m-px rounded"),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(format_clear, {
                        className: "text-gray-600 fill-current"
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/TextEditor/TextEditor.tsx







const TextEditor = (param)=>{
    let { content , onUpdate  } = param;
    const editor = (0,tiptap_react_esm/* useEditor */.jE)({
        editorProps: {
            attributes: {
                class: "px-3 py-3"
            }
        },
        extensions: [
            tiptap_starter_kit_esm/* default */.Z,
            tiptap_extension_link_esm/* default */.Z,
            tiptap_extension_highlight_esm/* default */.ZP
        ],
        content,
        onUpdate (param) {
            let { editor  } = param;
            onUpdate(editor.getHTML());
        }
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "py-0.5 border-b border-gray-300",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuBar, {
                    editor: editor
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    editor && /*#__PURE__*/ (0,jsx_runtime.jsx)(tiptap_react_esm/* BubbleMenu */.NM, {
                        className: "bubble-menu",
                        tippyOptions: {
                            duration: 100
                        },
                        editor: editor,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BubbleMenuBar, {
                            editor: editor
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(tiptap_react_esm/* EditorContent */.kg, {
                        editor: editor
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@hookform/error-message/dist/index.esm.js
var dist_index_esm = __webpack_require__(32866);
// EXTERNAL MODULE: ./components/Form/Styles.ts
var Styles = __webpack_require__(60487);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ./components/JobPost/editor/sections/DescriptionSection.tsx












const DescriptionSection = (param)=>{
    let { tags  } = param;
    const { getValues , watch , setValue , register , formState: { errors  } , clearErrors  } = (0,index_esm/* useFormContext */.Gc)();
    const { jobPost  } = getValues();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(JobPostEditorSectionLayout, {
        title: "",
        description: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                    label: "Title",
                    path: "jobPost.title",
                    register: register,
                    errors: errors
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-6 sm:col-span-6 lg:col-span-2 mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsGroup/* TagsGroup */.Y, {
                    heading: "Role",
                    availableTagTypes: [
                        types_tags/* TagType.ROLE */.Q.ROLE
                    ],
                    tags: tags,
                    name: "jobPost.userAssignedTags"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-6 sm:col-span-6 lg:col-span-2 mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsGroup/* TagsGroup */.Y, {
                    heading: "Experience",
                    availableTagTypes: [
                        types_tags/* TagType.EXPERIENCE_LEVEL */.Q.EXPERIENCE_LEVEL
                    ],
                    tags: tags,
                    name: "jobPost.userAssignedTags"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "col-span-6 sm:col-span-6 lg:col-span-2 mt-6",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagsGroup/* TagsGroup */.Y, {
                    heading: "Employment type",
                    availableTagTypes: [
                        types_tags/* TagType.EMPLOYMENT_TYPE */.Q.EMPLOYMENT_TYPE
                    ],
                    tags: tags,
                    name: "jobPost.userAssignedTags"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "col-span-6 sm:col-span-6 lg:col-span-2 mt-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "jobPost.description",
                        className: "block text-sm font-medium text-gray-700",
                        children: "Description"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,classNames/* classNames */.A)(get_default()(errors, "jobPost.description") ? "bg-red-50 border-red-500" : "", "mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextEditor, {
                            content: (jobPost === null || jobPost === void 0 ? void 0 : jobPost.description) || "",
                            onUpdate: (e)=>{
                                clearErrors("jobPost.description"), setValue("jobPost.description", e);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* ErrorMessage */.B, {
                        errors: errors,
                        name: "jobPost.description",
                        render: (param)=>/*#__PURE__*/ {
                            let { message  } = param;
                            return (0,jsx_runtime.jsx)("p", {
                                className: Styles/* defaultErrorMessageCN */.yr,
                                children: message
                            });
                        }
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/JobPost/editor/sections/NewUserSection.tsx





const NewUserSection = (param)=>{
    let { isLast  } = param;
    const { getValues , watch , setValue , register , formState: { errors  } , clearErrors  } = (0,index_esm/* useFormContext */.Gc)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostEditorSectionLayout, {
        title: "User details",
        description: "Provide your email address to create a new user account. This will be private and will NOT be shown in the JobPost.",
        isLast: isLast,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "col-span-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input/* Input */.I, {
                label: "Your email",
                path: "userEmail",
                register: register,
                errors: errors
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/menu/menu.js + 7 modules
var menu = __webpack_require__(17657);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 4 modules
var transition = __webpack_require__(31407);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(35871);
// EXTERNAL MODULE: ./utils/db/JobPost/getCompositeStatus.ts + 5 modules
var getCompositeStatus = __webpack_require__(20518);
// EXTERNAL MODULE: ./actions/actions.ts
var actions = __webpack_require__(30006);
// EXTERNAL MODULE: ./utils/actions/executeAction.ts
var executeAction = __webpack_require__(65481);
;// CONCATENATED MODULE: ./components/JobPost/editor/MoreMenu.tsx








const MoreMenuButton = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Button */.v.Button, {
        className: "focus:outline-none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "inline-block items-center ml-2 px-3 py-2 border border-transparent shadow-sm font-medium rounded-md text-black bg-transparent border-black hover:bg-black/10 focus:outline-none focus:ring-2 focus:ring-offset-2",
            children: [
                "More",
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon/* default */.Z, {
                    className: "inline h-4 w-4 ml-0.5 text-black"
                })
            ]
        })
    });
const getMoreMenuItems = (param)=>{
    let { jobPostId , compositeStatus , isJobPostDeletable , router  } = param;
    const items = [];
    if (compositeStatus === getCompositeStatus/* JobPostCompositeStatus.PUBLISHED */.L.PUBLISHED) {
        items.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: (param)=>/*#__PURE__*/ {
                let { active  } = param;
                return (0,jsx_runtime.jsx)("a", {
                    href: "",
                    className: "block px-4 py-2 text-black hover:bg-black/10",
                    onClick: async (e)=>{
                        e.preventDefault();
                        await (0,executeAction/* executeAction */.j)({
                            actionType: actions/* ActionType.JOB_POST__STOP */.U.JOB_POST__STOP,
                            jobPostId
                        });
                        router.reload();
                    },
                    children: "Unpublish"
                });
            }
        }, "stop"));
    }
    if (compositeStatus === getCompositeStatus/* JobPostCompositeStatus.STOPPED */.L.STOPPED) {
        items.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: (param)=>/*#__PURE__*/ {
                let { active  } = param;
                return (0,jsx_runtime.jsx)("a", {
                    href: "",
                    className: "block px-4 py-2 text-black hover:bg-black/10",
                    onClick: async (e)=>{
                        e.preventDefault();
                        await (0,executeAction/* executeAction */.j)({
                            actionType: actions/* ActionType.JOB_POST__RESUME */.U.JOB_POST__RESUME,
                            jobPostId
                        });
                        router.reload();
                    },
                    children: "Publish"
                });
            }
        }, "resume"));
    }
    if (jobPostId && isJobPostDeletable) {
        items.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Item */.v.Item, {
            children: (param)=>/*#__PURE__*/ {
                let { active  } = param;
                return (0,jsx_runtime.jsx)("a", {
                    href: "",
                    className: "block px-4 py-2 text-red-600 hover:bg-black/10",
                    onClick: async (e)=>{
                        e.preventDefault();
                        await (0,executeAction/* executeAction */.j)({
                            actionType: actions/* ActionType.JOB_POST__DELETE */.U.JOB_POST__DELETE,
                            jobPostId
                        });
                        router.push("/user/job-posts/my");
                    },
                    children: "Delete"
                });
            }
        }, "delete"));
    }
    return items;
};
const MoreMenu = (param)=>{
    let { jobPostId , compositeStatus , isJobPostDeletable  } = param;
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu */.v, {
        as: "span",
        className: "relative",
        children: (param)=>/*#__PURE__*/ {
            let { open  } = param;
            return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreMenuButton, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                        show: open,
                        as: react.Fragment,
                        enter: "transition ease-out duration-200",
                        enterFrom: "transform opacity-0 scale-95",
                        enterTo: "transform opacity-100 scale-100",
                        leave: "transition ease-in duration-75",
                        leaveFrom: "transform opacity-100 scale-100",
                        leaveTo: "transform opacity-0 scale-95",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* Menu.Items */.v.Items, {
                            static: true,
                            className: "origin-top-right fixed right-0 mt-2 left-0 text-lg rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none sm:absolute sm:left-auto sm:w-40 sm:text-sm",
                            children: getMoreMenuItems({
                                jobPostId,
                                compositeStatus,
                                isJobPostDeletable,
                                router
                            }).map((item)=>item)
                        })
                    })
                ]
            });
        }
    });
};

// EXTERNAL MODULE: ./components/JobPost/editor/components/JobPostPurchaseHistory.tsx
var JobPostPurchaseHistory = __webpack_require__(26353);
// EXTERNAL MODULE: ./services/mixpanel/index.ts
var mixpanel = __webpack_require__(81479);
// EXTERNAL MODULE: ./utils/redis/analytics/AnalyticsEvent.ts
var AnalyticsEvent = __webpack_require__(35571);
;// CONCATENATED MODULE: ./components/JobPost/editor/JobPostEditor.tsx

















var JobPostEditorPhase;
(function(JobPostEditorPhase) {
    JobPostEditorPhase[JobPostEditorPhase["CREATE"] = 0] = "CREATE";
    JobPostEditorPhase[JobPostEditorPhase["EDIT"] = 1] = "EDIT";
})(JobPostEditorPhase || (JobPostEditorPhase = {}));
const JobPostEditor = (param)=>{
    let { hasUser , phase , availableSkus , purchasedSkus , purchasedOrderItems , jobPost , tags , compositeStatus , isSticky , publishStartsAt , publishExpiresAt , stoppedAt  } = param;
    const router = (0,next_router.useRouter)();
    // Do we allow a user to delete the job post?
    const isJobPostDeletable = purchasedSkus.length === 0;
    // Selected SKUs state (SKUs to include with the order)
    // Any sku.isRequiredForJobPost === true that has not yet been purchased will be inculded in initialSelectedSkuIds (i.e. can't buy a promo if no publish)
    const initialSelectedSkuIds = availableSkus.filter((sku)=>sku.isRequiredForJobPost).map((sku)=>sku.id);
    const [selectedSkuIds, setSelectedSkuIds] = (0,react.useState)(initialSelectedSkuIds);
    // form
    const formMethods = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            jobPost: {
                taggerAssignedTags: [],
                userRejectedTags: [],
                userAssignedTags: [],
                ...jobPost,
                // We don't need to pollute the form with analytics data.
                analytics: undefined
            }
        }
    });
    const { handleSubmit , getValues , formState: { errors  } , setError  } = formMethods;
    // isSaving state
    const [isSaving, setIsSaving] = (0,react.useState)(false);
    // Method: Save.
    const save = async (data)=>{
        var ref;
        setIsSaving(true);
        const url = phase === JobPostEditorPhase.CREATE ? "/api/job-posts/create" : "/api/job-posts/".concat(jobPost.id, "/edit");
        const res = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
        });
        const result = await res.json();
        if (result.status === "error") {
            // console.log(result.errors);
            for (const [key, value] of Object.entries(result.errors)){
                // @ts-ignore:next-line
                setError(key, {
                    type: value.type,
                    message: value.message
                });
            }
        }
        const jobPostId = result === null || result === void 0 ? void 0 : (ref = result.jobPost) === null || ref === void 0 ? void 0 : ref.id;
        // If creating a new job post, change the url to become the edit url (we should now have the id).
        if (phase === JobPostEditorPhase.CREATE && hasUser && !!jobPostId) {
            const newUrl = window.location.href.replace("/create", "/".concat(jobPostId, "/edit"));
            await router.push(newUrl);
        }
        setIsSaving(false);
        return jobPostId;
    };
    // Method: Save & Preview.
    const saveAndPreview = async (data)=>{
        const jobPostId = await save(data);
        // Return early if no jobPostId.
        if (!jobPostId) {
            return;
        }
        // Preview.
        const modalQuery = {
            ...router.query,
            jobPostIdForModal: jobPostId
        };
        const modalHref = router.route + Object.entries(modalQuery).reduce((acc, param)=>{
            let [key, value] = param;
            return acc + "".concat(key, "=").concat(value, "&");
        }, "?");
        router.push(modalHref);
    };
    // Method: Checkout.
    const checkout = async (data)=>{
        var ref;
        // Save job post first.
        const jobPostId = await save(data);
        // Create new order.
        const url = "/api/job-posts/".concat(jobPostId, "/order/create");
        const res = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                includeSkus: selectedSkuIds
            })
        });
        const result = await res.json();
        // Mixpanel: Record checkout creation.
        (0,mixpanel/* mixpanelEvent */.f)({
            name: AnalyticsEvent/* AnalyticsEvent.CHECKOUT_CREATE */.s.CHECKOUT_CREATE,
            payload: {
                jobPostId: jobPostId,
                includeSkus: selectedSkuIds,
                orderId: result === null || result === void 0 ? void 0 : (ref = result.order) === null || ref === void 0 ? void 0 : ref.id
            }
        });
        // Is the value of any selectedSku larger than 0?
        const isCheckoutRequired = selectedSkuIds.map((skuId)=>{
            const sku = availableSkus.find((sku)=>sku.id === skuId);
            return sku.priceAmount;
        }).some((priceAmount)=>priceAmount > 0);
        // Redirect either to checkout or to success page (if checkout not needed).
        let newUrl = "";
        if (isCheckoutRequired) {
            var ref1;
            // Redirect to checkout.
            newUrl = "/checkout/session/create?order-id=".concat(result === null || result === void 0 ? void 0 : (ref1 = result.order) === null || ref1 === void 0 ? void 0 : ref1.id);
        } else {
            var ref2;
            // Redirect to success page.
            newUrl = "/checkout/success?order-id=".concat(result === null || result === void 0 ? void 0 : (ref2 = result.order) === null || ref2 === void 0 ? void 0 : ref2.id);
        }
        await router.push(newUrl);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* FormProvider */.RV, {
        ...formMethods,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "sticky top-16 -mt-8 z-20 bg-white",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hidden justify-between items-center py-5 px-0 border-b sm:flex",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                className: "text-3xl font-extrabold tracking-tight",
                                children: phase === JobPostEditorPhase.CREATE ? "New job post" : "Job Post"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex",
                            children: hasUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "text-sm",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "items-center ml-2 w-20 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-black focus:outline-none",
                                        onClick: handleSubmit(save),
                                        children: isSaving ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spinners.BeatLoader, {
                                                size: 6,
                                                margin: 3,
                                                color: "white"
                                            })
                                        }) : "Save"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "button",
                                        className: "items-center ml-2 w-20 py-2 border border-transparent shadow-sm font-medium rounded-md text-black bg-transparent border-black hover:bg-black/10 focus:outline-none",
                                        onClick: handleSubmit(saveAndPreview),
                                        children: isSaving ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_spinners.BeatLoader, {
                                                size: 6,
                                                margin: 3,
                                                color: "black"
                                            })
                                        }) : "Preview"
                                    }),
                                    getMoreMenuItems({
                                        jobPostId: jobPost === null || jobPost === void 0 ? void 0 : jobPost.id,
                                        compositeStatus,
                                        isJobPostDeletable,
                                        router
                                    }).length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreMenu, {
                                        jobPostId: jobPost === null || jobPost === void 0 ? void 0 : jobPost.id,
                                        compositeStatus: compositeStatus,
                                        isJobPostDeletable: isJobPostDeletable
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-1 lg:flex items-stretch mt-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: "flex-1 overflow-y-auto",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            "aria-labelledby": "primary-heading",
                            className: "min-w-0 flex-1 h-full flex flex-col overflow-hidden lg:order-last",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "sm:mr-4",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                    onSubmit: handleSubmit(save),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "m-0.5 mb-6 py-2 shadow bg-white sm:rounded-md sm:overflow-hidden",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DescriptionSection, {
                                                tags: tags
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CompensationSection, {
                                                tags: tags
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(HiringOrganisationSection, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocationSection, {
                                                tags: tags
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ApplySection, {
                                                isLast: hasUser
                                            }),
                                            !hasUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(NewUserSection, {
                                                isLast: true
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("aside", {
                        className: "sm:w-96",
                        children: [
                            hasUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostSummary/* JobPostSummary */.O, {
                                    jobPostId: jobPost === null || jobPost === void 0 ? void 0 : jobPost.id,
                                    compositeStatus: compositeStatus,
                                    isSticky: isSticky,
                                    createdAt: jobPost === null || jobPost === void 0 ? void 0 : jobPost.createdAt,
                                    publishStartsAt: publishStartsAt,
                                    publishExpiresAt: publishExpiresAt,
                                    stoppedAt: stoppedAt,
                                    analytics: jobPost === null || jobPost === void 0 ? void 0 : jobPost.analytics
                                })
                            }),
                            availableSkus.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostPublish, {
                                selectedSkuIds: selectedSkuIds,
                                setSelectedSkuIds: setSelectedSkuIds,
                                availableSkus: availableSkus,
                                onSubmit: handleSubmit(checkout)
                            }),
                            (purchasedOrderItems === null || purchasedOrderItems === void 0 ? void 0 : purchasedOrderItems.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-6",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JobPostPurchaseHistory/* JobPostPurchaseHistory */.F, {
                                    orderItems: purchasedOrderItems
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 39371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ TagsGroup; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _utils_classNames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43153);
/* harmony import */ var react_hook_form__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87536);



const TagsGroup = (param)=>{
    let { heading , availableTagTypes , tags , name  } = param;
    // Get form context.
    const { watch , setValue  } = (0,react_hook_form__WEBPACK_IMPORTED_MODULE_1__/* .useFormContext */ .Gc)();
    // Get currently assigned tags.
    const assignedTags = watch(name);
    // Method: toggleAssignedTag.
    const toggleAssignedTag = (tagId)=>{
        const tag = assignedTags.find((tag)=>tag.id === tagId);
        if (tag) {
            setValue(name, assignedTags.filter((tag)=>tag.id !== tagId), {
                shouldValidate: false
            });
        } else {
            setValue(name, [
                ...assignedTags,
                {
                    id: tagId,
                    score: 100
                }
            ], {
                shouldValidate: false
            });
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("fieldset", {
        className: "",
        children: [
            heading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mb-1 text-sm font-medium",
                children: heading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "",
                children: tags.filter((tag)=>availableTagTypes.includes(tag.type)).map((tag)=>{
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                        type: "button",
                        className: (0,_utils_classNames__WEBPACK_IMPORTED_MODULE_2__/* .classNames */ .A)("mr-0.5 mb-1 px-2 py-1 text-sm border rounded-sm bg-gray-100 hover:bg-gray-200", (assignedTags === null || assignedTags === void 0 ? void 0 : assignedTags.findIndex((t)=>t.id === tag.id)) > -1 && "bg-blue-300 hover:bg-blue-400"),
                        onClick: ()=>{
                            toggleAssignedTag(tag.id);
                        },
                        children: tag.label || tag.id
                    }, tag.id);
                })
            })
        ]
    });
};


/***/ }),

/***/ 39223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DQ": function() { return /* binding */ ORGANISATIONS_AUTOCOMPLETE_LIMIT; },
/* harmony export */   "Rr": function() { return /* binding */ JOB_POST_PUBLISH_DURATION_IN_DAYS; },
/* harmony export */   "Wt": function() { return /* binding */ QUALITY_SCORE_THRESHOLD; }
/* harmony export */ });
/* unused harmony exports ES_DEFAULT_DISTANCE_IN_KM, TAG_SCORE_THRESHOLD */
// CLIENT CONFIG (public)
const JOB_POST_PUBLISH_DURATION_IN_DAYS = 28;
const ES_DEFAULT_DISTANCE_IN_KM = 100;
const TAG_SCORE_THRESHOLD = 30;
const QUALITY_SCORE_THRESHOLD = 30;
const ORGANISATIONS_AUTOCOMPLETE_LIMIT = 10;


/***/ }),

/***/ 75474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ TagType; }
/* harmony export */ });
/* unused harmony export TagClassifierEngine */
var TagType;
(function(TagType) {
    TagType["JOB_POST_META"] = "JOB_POST_META";
    TagType["JOB"] = "JOB";
    TagType["COMPENSATION_BENEFIT"] = "COMPENSATION_BENEFIT";
    TagType["ORGANISATION"] = "ORGANISATION";
    TagType["ROLE"] = "ROLE";
    TagType["EXPERIENCE_LEVEL"] = "EXPERIENCE_LEVEL";
    TagType["PROGRAMMING_LANGUAGE"] = "PROGRAMMING_LANGUAGE";
    TagType["TECHNOLOGY"] = "TECHNOLOGY";
    TagType["MARKET"] = "MARKET";
    TagType["EMPLOYMENT_TYPE"] = "EMPLOYMENT_TYPE";
})(TagType || (TagType = {}));
var TagClassifierEngine;
(function(TagClassifierEngine) {
    TagClassifierEngine["KEYWORD_MATCH"] = "KEYWORD_MATCH";
    TagClassifierEngine["ROLE_MATCH"] = "ROLE_MATCH";
    TagClassifierEngine["IS_4_DAY_WEEK"] = "IS_4_DAY_WEEK";
    TagClassifierEngine["IS_OUTSIDE_IR35"] = "IS_OUTSIDE_IR35";
    TagClassifierEngine["IS_VISA_SPONSORED"] = "IS_VISA_SPONSORED";
    TagClassifierEngine["IS_RELOCATION_PAID"] = "IS_RELOCATION_PAID";
    TagClassifierEngine["IS_FULLY_REMOTE"] = "IS_FULLY_REMOTE";
})(TagClassifierEngine || (TagClassifierEngine = {}));


/***/ }),

/***/ 22536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ compensationUnitToLabel; }
/* harmony export */ });
/* harmony import */ var _prisma_client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70385);
/* harmony import */ var _prisma_client__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_prisma_client__WEBPACK_IMPORTED_MODULE_0__);

const compensationUnitToLabel = {
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.CompensationUnit.HOUR]: "Hour",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.CompensationUnit.DAY]: "Day",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.CompensationUnit.WEEK]: "Week",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.CompensationUnit.MONTH]: "Month",
    [_prisma_client__WEBPACK_IMPORTED_MODULE_0__.CompensationUnit.YEAR]: "Year"
};


/***/ })

}]);